import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Null when env vars are absent (e.g. local dev without a .env, or the
// Supabase project not provisioned yet) so public pages still render;
// consumers must handle the null client.
export const supabase = url && anonKey ? createClient(url, anonKey) : null;

if (!supabase && process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  console.warn(
    'Supabase env vars missing (REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY); backend features disabled.'
  );
}
